import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { RpieNonFiler } from '../types';
import { TableHeader } from './TableHeader';

interface PropTypes {
  rpieData: RpieNonFiler[];
}

const TableRow = ({ rpie }: { rpie: RpieNonFiler }) => (
  <Table.Row>
    <Table.Cell collapsing>{rpie.borough}</Table.Cell>
    <Table.Cell collapsing>{rpie.address}</Table.Cell>
    <Table.Cell collapsing>{rpie.block}</Table.Cell>
    <Table.Cell collapsing>{rpie.lot}</Table.Cell>
    <Table.Cell collapsing>{rpie.rpieYear}</Table.Cell>
    <Table.Cell collapsing>{rpie.bldgClass}</Table.Cell>
  </Table.Row>
);

const RpieDataTab = (props: PropTypes) => {
  const [sortedRpieData, setSortedRpieData] = useState<RpieNonFiler[]>([]);

  useEffect(() => {
    if (props.rpieData) {
      setSortedRpieData(props.rpieData);
    }
  }, [props.rpieData]);

  return (
    <React.Fragment>
      {sortedRpieData.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={12} sortable>
          <TableHeader
            columnNames={['Borough', 'Address', 'Block', 'Lot', 'Rpie Year', 'Building Class']}
            sortedData={sortedRpieData}
            setSortedData={setSortedRpieData}
          />
          <Table.Body>
            {sortedRpieData.map(rpie => (
              <TableRow rpie={rpie} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default RpieDataTab;
